const columns= [
    {
        title: 'Message',
        dataIndex: 'message',
    },
    {
        title: 'Update Date',
        dataIndex: 'createdDate',      
    },
  
   
];

export default columns;